function bubbleClass(isMine, role) {
  if (isMine) return "bg-[var(--gold)] text-[var(--navy-on-gold)]";
  if (role === "instructor") return "bg-[var(--gold-bright)] text-[var(--navy-on-gold)]";
  return "bg-[var(--paper-soft)] text-[var(--gold-soft)]";
}

export default function ChatMessage({ message, isMine }) {
  return (
    <div className={`flex ${isMine ? "justify-end" : "justify-start"}`}>
      <div className={`max-w-[78%] border-2 border-[var(--gold)] rounded-2xl px-4 py-2 ${bubbleClass(isMine, message.user_role)}`}>
        <div className="flex items-center gap-2 mb-0.5">
          <span className="text-xs font-bold">{isMine ? "You" : message.user_name}</span>
          {message.user_role === "instructor" && (
            <span className="text-[9px] font-bold border border-[var(--navy-on-gold)] rounded px-1 bg-[var(--paper)] text-[var(--gold)]">
              PROF
            </span>
          )}
        </div>
        <p className="text-sm whitespace-pre-wrap break-words">{message.text}</p>
      </div>
    </div>
  );
}
